import axios from 'axios';

const save = async (payload: {
  name: string;
  teamId?: string;
  users?: string[];
  email?: string;
  phone?: string;
  website?: string;
  teamMlsId?: string;
}) => {
  const { name, teamId, users, email, phone, website, teamMlsId } = payload;
  let url = '/team';
  if (teamId) url += `/${teamId}`;
  return axios.post(url, { name, users, email, phone, website, teamMlsId });
};

export default save;
